import { useState, useContext, useEffect } from "react";
import styles from "../Settings.module.css";
import PluginsContext from "config/context/pluginsContext";
import GuiContext from "config/context/guiContext";
import ThemeContext from "config/context/themeContext";
import EncryptionContext from "config/context/encryptionContext";
import BackUp from "components/settings/BackUp";
import ModalContext from "config/context/modalContext";
import PrivateKeyStorageModal from "features/permissions/components/modals/PrivateKeyStorageModal";
import EnableEncryptionSettings from "./EnableEncryptionSettings";
import { useModalSystem } from "config/context/ModalSystemContext";

// Van tela komponente, iz istog razloga kao u `PermissionActions`.
const initialModalState = {
  privateKey: false,
};

/**
 * Pluginovi koji vode u čarobnjak za uvoz: 6 (CSV/JSON/XML), 8 (Redis),
 * 10 (Mongo), 11 (MySQL). Bilo koji od njih otvara isti ulaz, jer je iza
 * njega jedan čarobnjak sa svim izvorima.
 *
 * Spisak stoji ovde, a ne izvodi se iz kataloga, jer katalog traži poziv
 * servera — a ovo je samo odluka da li se jedna stavka uopšte crta. Kad se
 * doda nov uvozni plugin, dopuniti i ovde.
 */
const UVOZNI_PLUGINOVI = [6, 8, 10, 11];

const PluginSettings = () => {
  const { getActiveByAccountName } = useContext(PluginsContext);
  const { modal, handleModal } = useContext(ModalContext);
  // const [openModal, setOpenModal] = useState(false);
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [modalControl, setModalControl] = useState({ ...initialModalState });
  const handleDropDown = () => setDropDownOpen((prev) => !prev);
  const [encryptionSettings, setEncryptionSettings] = useState(false);

  const {
    userData: { guiname },
  } = useContext(GuiContext);
  const { setEncryptionToDefault, encryption } = useContext(EncryptionContext);
  const { openModal } = useModalSystem();

  const { dark } = useContext(ThemeContext);
  const [active, setActive] = useState([]);
  //     [("1","Encryption"),
  //     ("2", "Backup", ),
  //     ("3", "Replica sync",),
  //     ("4", "MongoDB proxy", ),
  //     ("5", "Export data"),
  //     ("6", "SQL Connector"),
  //     ("7", "Hot Key"),
  //     ("8", "Import Redis"),
  //     ("10", "Import Mongo"),
  //     ("12", "AI Database Architect")
  // ]

  useEffect(() => {
    let activePluginsByAccount = getActiveByAccountName(guiname);
    if (activePluginsByAccount?.active)
      setActive(activePluginsByAccount?.active);
    // `getActiveByAccountName` je `useCallback` nad spiskom pluginâ, pa se
    // provera ponovi kad se plugin uključi ili isključi — a to je i ispravno.
  }, [guiname, getActiveByAccountName]);

  const showModal = (modalName) => {
    setModalControl(prev => ({ ...prev, [modalName]: true }));
    handleModal(true);
  };

  useEffect(() => {
    if (!modal) {
      setModalControl({ ...initialModalState });
    }
  }, [modal]);

if(!active?.length) {
  return(<p>You don't have any activated plugins yet.</p>)
}

  return (
    <section className={styles.pluginSettings}>
      <div className={styles.settingsContainer}>
        {active.includes(7) && (
          <div onClick={() => showModal('privateKey')}>
            <img
              src={`../img/settings/pkeyStore${dark ? "-dark" : ""}.svg`}
              alt="pkeyStore"
            />
            Temporarily store the Private Key
          </div>
        )}
        {active.includes(1) && (
          <div onClick={() => { encryption ? setEncryptionToDefault() : setEncryptionSettings(true); }}>
            <img
              src={`../img/settings/encryption${dark ? "-dark" : ""}.svg`}
              alt="encryption"
            />
            <>{encryption ? "Disable" : "Enable"} Encryption</>
            {encryptionSettings && <EnableEncryptionSettings setEncryptionSettings={setEncryptionSettings}/>}
          </div>
        )}
        {active.includes(2) && (
          <div onClick={handleDropDown}>
            <img
              src={`../img/settings/backup${dark ? "-dark" : ""}.svg`}
              alt="backup"
            />
            Server Backup
          </div>
        )}
        {dropDownOpen && (
          <>
            <BackUp className={styles.dropDownOptions} />
          </>
        )}
        {/*
            Zasebni dijalozi za Redis i Mongo su UKLONJENI. Gađali su stare
            rute (`/api/plugins/{redis,mongo}_import`) na kojima Mongo puca na
            datumu bez vremena, a stajali su odmah uz čarobnjak — pa je za Mongo
            uvoz bilo prirodno posegnuti baš za njima i završiti u zatečenom
            kodu. Oba izvora su sada u „MultiFormat Import" ispod, zajedno sa
            CSV, JSON, XML i MySQL, sa formom koja se gradi iz kataloga.
        */}
        {/*
            Ulaz u čarobnjak za uvoz.

            Do 28.09.2026. je uslov bio samo `active.includes(6)`, pa je onaj ko
            je uključio MySQL (11), Redis (8) ili Mongo (10) a nije i 6 ostajao
            BEZ ulaza — plugin instaliran, a neupotrebljiv. Otud i natpis koji
            više ne imenuje jedan plugin: iza ovog dugmeta su svi uvozni izvori,
            a koji su od njih na raspolaganju kaže sam čarobnjak.
        */}
        {UVOZNI_PLUGINOVI.some((id) => active.includes(id)) && (
          <div onClick={() => openModal('MF_IMPORT')}>
            <img
              width={18}
              src={`../img/settings/multiformat${dark ? "-dark" : ""}.svg`}
              alt="Import data"
            />
            Import data through available plugins
          </div>
        )}
      </div>
      {modalControl.privateKey && <PrivateKeyStorageModal />}
    </section>
  );
};

export default PluginSettings;
